<template>
  <div
    style="
      background: linear-gradient(
        to bottom right,
        rgba(37, 55, 65, 1),
        rgba(66, 98, 116, 0.9)
      );
    "
    class="content"
  >
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped></style>
